import React, { useState } from 'react';
import i18n from 'i18next';
import { Link } from '@inertiajs/inertia-react';
import '@inertiajs/inertia-react';
import { Modal } from "react-bootstrap";

export default function UpgradeTodayModal(props) {
    const { show, onHide } = props;

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {i18n.t("upgrade-today-modal.upgrade-today")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="upgrade-today">
                    <p>{i18n.t("upgrade-today-modal.your-estimated-fee")} $91.32/{i18n.t("upgrade-today-modal.month")}.<br/>{i18n.t("upgrade-today-modal.talk-to-us")}</p>
                    <div className="row">
                        <div className="col-6">
                            <div className="upgrade-option">
                                <i className="fas fa-phone"></i>
                                <span>{i18n.t("upgrade-today-modal.call-us")}</span>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="upgrade-option">
                                <i className="fas fa-comments"></i>
                                <span>{i18n.t("upgrade-today-modal.start-live-chat")}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="btn btn-sm btn-outline-secondary" onClick={props.onHide}>{i18n.t("upgrade-today-modal.cancel")}</div>
            </Modal.Footer>
        </Modal>
    );
}